import React from 'react';
import './Avatar.css';

interface AvatarProps {
  size: number;
  src?: string;
  account_type?: string;
  onLoad?: () => void;
  onError?: () => void;
}

const Avatar: React.FC<AvatarProps> = ({ 
  size, 
  src, 
  account_type = 'user',
  onLoad,
  onError 
}) => {
  const handleImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    // console.log('Image loaded:', src);  // Debug log
    if (e.currentTarget.complete) {  // Check if image is actually loaded
      onLoad?.();
    }
  };

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    console.error('Failed to load avatar image:', src);
    e.currentTarget.style.display = 'none';
    onError?.();
  };

  if (account_type === 'brand') {
    return (
      <div 
        className="brand-avatar-container"
        style={{
          width: `${size}px`,
          height: `${size}px`,
        }}
      >
        <div className="brand-avatar-gradient">
          <div className="brand-avatar-inner">
            <img 
              src={src} 
              alt="Brand Avatar" 
              style={{ 
                width: `${size}px`, 
                height: `${size}px`,
                objectFit: 'cover'
              }} 
              onError={handleImageError}
              onLoad={handleImageLoad}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="user-avatar"
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
    >
      <img 
        src={src} 
        alt="User Avatar" 
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'cover' 
        }} 
        onError={handleImageError}
        onLoad={handleImageLoad}
      />
    </div>
  );
};

export default Avatar;
